import theme from "../../../style/theme";
// import { CoordinatePinProps } from "../../../types/Pin/coordinate-pin";
import { CoordinatePin } from "./CoordinatePin";
import { CoordinatePinProps } from "./coordinate-pin-props";

export const YellowCoordinatePin: React.FC<CoordinatePinProps> = ({
  memberName,
  title,
  leftBody,
  leftBodyColor,
  rightBody,
  footer,
  positionStyle,
  id,
  ...rest
}) => {
  return (
    <CoordinatePin
      backgroundColor={theme.palette.primitives["yellow400"]}
      hoverBackgroundColor="#deb200"
      color={theme.palette.primitives["black"]}
      hoverColor={theme.palette.primitives["black"]}
      memberName={memberName}
      title={title}
      leftBody={leftBody}
      leftBodyColor={leftBodyColor}
      rightBody={rightBody}
      footer={footer}
      positionStyle={positionStyle}
      id={id}
      {...rest}
    />
  );
};
